var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"chb-countries-overview"}},[(_vm.isLoading)?_c('div',{staticClass:"p-page__section theme--light"},[_c('overlay-loading')],1):_vm._e(),_c('ChbPageHeader'),(_vm.loggedInUser.isCHBAdmin)?_c('ChbCountriesTable'):_c('NoAccess'),(_vm.modalIsVisible)?_c('ChbModal'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }